export enum ViewMode {
  Map = '2d',
  Scene = '3d',
}
